<!--
 * @Descripttion: 
 * @version: 
 * @Author: zhouxh
 * @Date: 2023-05-22 16:56:12
-->
<template>
  <div class="enthonor-container">

    <div class="submenu-wrapper">
      <Submenu 
      :engLabel="englabel"
      :cnLabel="cnLabel"
      :linkData="linkData"
    />
    </div>

    <div class="main-wrapper py-2 py-md-5 px-2">
      <!-- 东久电子取得的主要成绩及荣誉 -->
        <div class="company-honor my-2 my-md-5">
          <h3 class="overview-title">东久电子取得的主要成绩及荣誉</h3>
          <div class="row align-items-start justify-content-center">
            <div class="col-12 col-md-8 honor-introduct mt-5 my-md-0 mx-2 mx-md-0">
               
              <h4 class="my-2">公司荣誉:</h4>
              <p class="introduce-paragraph" v-for="par,index in paragraphList" :key="index">{{ par }}</p>
           </div>
          </div>

        </div>


        <!-- 公司商标 -->
        <div class="img-wrapper ">
          <p class="split-header">公司商标</p>
            <div class="row justify-content-start justify-content-md-center mt-3">
                  <div class="col-12 col-md-4 col-lg-3 my-2 mx-1 mx-md-2" v-for="item in brandData" :key="item">
                    <div class="patent-img my-2 my-md-4">
                        <ImagePreview
                          :src="item"
                          :height="398"
                          :width="308"
                          :previewurl="getPreviewurl(item)"
                          fit="fill"
                        />
                    </div>
                </div>
             </div>
        </div>


      <!-- 客户荣誉 -->
       <div class="img-wrapper">
          <div class="row justify-content-center">
            <div class="col-12 col-md-10">
              <h4 class="my-2">来自政府及客户授予荣誉:</h4>

              <p class="split-header">公司荣获2项国家荣誉，5项上海市荣誉，20+主机厂荣誉。</p>
              <div class="my-2 pd-2 pd-md-3 honor-wrapper" v-for="item in honorData" :key="item.id">
                <div class="row  my-2 mx-my-4 mx-1 mx-md-4 justify-content-center" >

                    <p class="split-header">{{item.text}}</p>
                    <div class="col-12 col-md-3 my-2 mx-my-4 mx-1 mx-md-4" v-for="items,index in item.img" :key="index">

                      <ImagePreview
                      :src="items"
                      :height="238"
                      :previewurl="getPreviewurl(items)"
                      fit="scale-down"
                      />
                    </div> 

                    </div>
              </div>
         


            </div> 
         </div>
        </div>




        <!-- 企业荣誉 - 响应式轮播图 -->
        <div class="img-wrapper ">
          <p class="split-header">其它荣誉</p>
          <div class="row justify-content-center">
            <div class="col-12 col-xl-8 ">
              <ImageLoader 
                :src="img2"
                :height="img2Height"
                fit="fill"
                />
            </div>
            </div>

          
          <!-- <div class="row justify-content-center">
            <div class="col-12 col-xl-10" id="other-honor">

              <div class="honor-carousel-container">
                <div 
                  class="honor-carousel" 
                  ref="honorCarousel"
                  :style="{ transform: `translateX(-${currentSlide * (100 / getVisibleCount())}%)` }"
                >
                  <div 
                    class="honor-slide" 
                    v-for="(honor, index) in otherHonorData" 
                    :key="index"
                    :class="{ 'active': index >= currentSlide && index < currentSlide + getVisibleCount() }"
                    @click="previewHonor(honor, index)"
                  >
                    <div class="honor-image-wrapper">
                      <img 
                        :src="honor.src" 
                        :alt="honor.title"
                        class="honor-image"
                      />
                      <div class="honor-overlay">
                        <div class="honor-title">{{ honor.title }}</div>
                        <div class="honor-year">{{ honor.year }}</div>
                      </div>
                    </div>
                  </div>
                </div>
                

                <button 
                  class="carousel-btn prev-btn" 
                  @click="prevSlide"
                  :disabled="otherHonorData.length <= getVisibleCount()"
                >
                  ‹
                </button>
                <button 
                  class="carousel-btn next-btn" 
                  @click="nextSlide"
                  :disabled="otherHonorData.length <= getVisibleCount()"
                >
                  ›
                </button>
                

                <div class="carousel-indicators" v-if="otherHonorData.length > getVisibleCount()">
                  <span 
                    v-for="(indicator, index) in getIndicatorCount()" 
                    :key="index"
                    class="indicator"
                    :class="{ 'active': Math.floor(currentSlide / getVisibleCount()) === index }"
                    @click="goToSlide(index * getVisibleCount())"
                  ></span>
                </div>
              </div>
            </div> 
         </div> -->


        </div>


      <!-- 证书描述 -->
      <!-- <div class="img-wrapper">
          <div class="row justify-content-center">
 
             <div class="col-12 col-xl-8 ">
              <ImageLoader 
                :src="img2"
                :height="img2Height"
                fit="fill"
                />
            </div>
         </div>
        </div> -->

      </div>

      <!-- 图片预览模态框 -->
      <div 
        v-if="showPreview" 
        class="preview-modal"
        @click="closePreview"
      >
        <div class="preview-content" @click.stop>
          <button class="close-btn" @click="closePreview">&times;</button>
          <button class="nav-btn prev-btn" @click="prevPreview" v-if="otherHonorData.length > 1">‹</button>
          <button class="nav-btn next-btn" @click="nextPreview" v-if="otherHonorData.length > 1">›</button>
          <img 
            :src="currentPreviewImage.src" 
            :alt="currentPreviewImage.title"
            class="preview-image"
          />
          <div class="preview-info">
            <h3>{{ currentPreviewImage.title }}</h3>
            <p>{{ currentPreviewImage.year }}</p>
            <p>{{ currentPreviewImage.description }}</p>
          </div>
        </div>
      </div>

  </div>
</template>

<script>
import { AboutLink } from "@/assets/js/submenulink.js";
import { getHonorIntroduct } from "@/api/enterpHonor.js";
import Submenu from "@/components/Submenu/";
import ImageLoader from "@/components/ImageLoader/";
import ImagePreview from "@/components/ImagePreview";
export default {
   components: {
    Submenu,
    ImageLoader,
    ImagePreview,
   },
  
   data() {
    return {
      englabel: 'ABOUT US',
      cnLabel: '关于东久电子',

      honorData:[],//企业荣誉

      imgHeight: 568,
      img_aspect_ratio: (1237 / 516).toFixed(2),


      img2Height: 516,
      img2_aspect_ratio: (1237 / 516).toFixed(2),


      windowSize: {},
      linkData: [],
      img: require("@/assets/img/About/qiyerongyu/qiyerongyu.png"),
      img2:  require("@/assets/img/About/qiyerongyu1/qita.png"),
      // 轮播图相关数据
      currentSlide: 0,
      showPreview: false,
      currentPreviewIndex: 0,
      otherHonorData: [
        {
          id: 1,
          src: require("@/assets/img/About/qiyerongyu1/qitarongyu/01.png"),
          title: "ASPICE证书01",
          year: "2024年",
          description: "ASPICE证书01"
        },

        {
          id: 2,
          src: require("@/assets/img/About/qiyerongyu1/qitarongyu/02.png"),
          title: "ASPICE证书02",
          year: "2024年",
          description: "ASPICE证书02"
        },

        
        {
          id: 3,
          src: require("@/assets/img/About/qiyerongyu1/qitarongyu/03.png"),
          title: "上海专精特新企业",
          year: "",
          description: "上海专精特新企业"
        },
        
        {
          id: 4,
          src: require("@/assets/img/About/qiyerongyu1/qitarongyu/04.png"),
          title: "上海市科学技术奖",
          year: "",
          description: "上海市科学技术奖"
        },

        {
          id: 5,
          src: require("@/assets/img/About/qiyerongyu1/qitarongyu/05.png"),
          title: "国家863计划项目",
          year: "",
          description: "国家863计划项目"
        },

        {
          id: 6,
          src: require("@/assets/img/About/qiyerongyu1/qitarongyu/06.png"),
          title: "专利证书",
          year: "",
          description: "专利证书"
        },

        {
          id: 7,
          src: require("@/assets/img/About/qiyerongyu1/qitarongyu/07.png"),
          title: "主机厂荣誉",
          year: "",
          description: "主机厂荣誉"
        },


        {
          id: 8,
          src: require("@/assets/img/About/qiyerongyu1/qitarongyu/08.png"),
          title: "环境管理体系证书",
          year: "2024年",
          description: "环境管理体系证书"
        },

        {
          id: 9,
          src: require("@/assets/img/About/qiyerongyu1/qitarongyu/09.png"),
          title: "职业健康安全管理证书",
          year: "2024年",
          description: "职业健康安全管理证书"
        },

        {
          id: 10,
          src: require("@/assets/img/About/qiyerongyu1/qitarongyu/10.png"),
          title: "IATF16949证书-潜江分公司",
          year: "2024",
          description: "IATF16949证书-潜江分公司"
        },

        {
          id: 11,
          src: require("@/assets/img/About/qiyerongyu1/qitarongyu/11.png"),
          title: "IATF16949证书-新乐分公司",
          year: "2024",
          description: "IATF16949证书-新乐分公司"
        },
  
      ],

      brandData:[
            require("@/assets/img/About/qiyerongyu1/ejlae.png"),
            require("@/assets/img/About/qiyerongyu1/久乐电子.png"),
            require("@/assets/img/About/qiyerongyu1/东久电子.png")
      ],

      paragraphList: [
     " 2013年2月，东久电子和新乐分公司通过ISO/TS16949:2009质量体系认证；",
     " 2013年9月，东久电子认定为上海市高新技术企业；",
     " 2013年10月，产品车窗防夹控制器（APM）认定为上海市高新技术成果转化项目；",
      "2015年12月，东久电子认定为小巨人培育企业；",
     " 2015年7月，东久电子认定为“专精特新”企业；",
      "2016年9月，东久电子高新技术企业复审通过，并加入上海市高新技术企业协会；",
     " 2016年通过上海市科技小巨人（培育）企业认定，并于2018年3月顺利验收；",
     " 2017年7月，东久电子“专精特新”企业复审通过；",
     " 2017年3月，车身控制器软件V1.0（BCM）申请为软件著作权；",
     " 2017年承担上海市经信委汽车和工业MEMS高精度惯性和卫星组合导航系统项目科研；",
     " 2018年3月，东久电子认定为浦东新区研发机构；",
      "2019年通过上海市高新技术企业复审继续获得高新技术企业认定；",
      "2021年8月通过工业强基项目-汽车和工业用MEMS高精度惯性和卫星组合导航系统的验收；",
     " 2021年通过国家工信部专精特新“小巨人”企业认定",
      "2022年认定为“小巨人”企业",
      "2022年东久电子“专精特新”企业复审通过；",
     " 2022年1月，安全气囊控制器V1.0申请为软件著作权；",
      "2022年3月，车窗防夹控制器V1.0申请为软件著作权；",
     " 2022年3月，座椅控制器V1.0申请为软件著作权；",
      "2022年，东久电子认定为科技小巨人企业；",
      "2022年12月，东久电子复核通过高新技术企业认定；",
     " 2023年6月，东久电子认定为浦东新区战略新兴产业培育企业；",
      "2023年9月，东久电子通过CNAS实验室认证；",
      "2024年1月，东久电子认定为浦东新区营运总部；",
      "2024年5月，东久电子获得上海专精特新“小巨人”企业品牌价值榜“百佳企业”称号；",
      "2024年9月，东久电子通过工信部的专精特新“小巨人”企业复核；",
     " 2025年2月，东久电子获得浦东新区合庆镇政府颁发的合庆领航奖;",
     "2025年9月，东久电子认定为上海市企业技术中心;",
     "2025年11月，东久电子认定为上海市专家工作站;",
     "2025年12月，东久电子通过高新技术企业复核。",

      ]
    }
  },

  computed: {
    currentPreviewImage() {
      return this.otherHonorData[this.currentPreviewIndex] || {}
    }
  },

  created() {
      this.getWindowSize();
      this.linkData = AboutLink;
      this.getHonorData();
   },

  mounted() {
      //拉伸窗口时触发
      window.onresize = () => {
          this.getWindowSize();
          
      }

  },
   methods: {



    getHonorData() {
      getHonorIntroduct().then(res => {
              this.honorData = res.reverse();
            });
        },
    getWindowSize() {
         this.windowSize.width =   document.documentElement.clientWidth || document.body.clientWidth; 
         this.windowSize.Height =  document.documentElement.clientHeight || document.body.clientHeight; 
         this.imgHeight = Math.round(this.windowSize.width / this.img_aspect_ratio); 
        },

  getPreviewurl(item){
    return [item];
  },

  // 轮播图相关方法
  getVisibleCount() {
    const width = this.windowSize.width || window.innerWidth
    if (width >= 1200) return 6  // 大屏显示6张
    if (width >= 992) return 4   // 中屏显示4张
    if (width >= 768) return 3   // 小屏显示3张
    if (width >= 576) return 2   // 更小屏显示2张
    return 1  // 最小屏显示1张
  },

  getIndicatorCount() {
    return Math.ceil(this.otherHonorData.length / this.getVisibleCount())
  },

  nextSlide() {
    const visibleCount = this.getVisibleCount()
    const maxSlide = Math.max(0, this.otherHonorData.length - visibleCount)
    this.currentSlide = Math.min(this.currentSlide + 1, maxSlide)
  },

  prevSlide() {
    this.currentSlide = Math.max(0, this.currentSlide - 1)
  },

  goToSlide(index) {
    this.currentSlide = index
  },

  previewHonor(honor, index) {
    this.currentPreviewIndex = index
    this.showPreview = true
  },

  closePreview() {
    this.showPreview = false
  },

  nextPreview() {
    this.currentPreviewIndex = (this.currentPreviewIndex + 1) % this.otherHonorData.length
  },

  prevPreview() {
    this.currentPreviewIndex = (this.currentPreviewIndex - 1 + this.otherHonorData.length) % this.otherHonorData.length
  },
   }


}
</script>

<style scoped lang="less">
@import "~@/styles/global.less";
  .enthonor-container{
    position: relative;;
    width: 100%;;
    height: auto;
    .general-layout

 

    .company-honor{
      position: relative;
      width: 100%;
      height: auto;

    }

    .overview-title{
      text-align: center;
      font-weight: 700;
      color: black !important;
    }

    h4{
       font-weight: bold;
       color:@words;
       margin-top: 5rem;
       margin-bottom: 2rem;
    }

    .honor-wrapper{
      padding: 3rem 0;
      border-bottom: 1px solid @words;
    }


    .img-wrapper{
      margin:5rem 0;

      h4{
        text-align: center;
      }
    }

    // 轮播图样式
    .honor-carousel-container {
      position: relative;
      width: 100%;
      overflow: hidden;
      border-radius: 15px;
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
    }

    .honor-carousel {
      display: flex;
      transition: transform 0.5s ease-in-out;
      transform: translateX(0);
    }

    .honor-slide {
      flex: 0 0 auto;
      width: calc(100% / 6); // 默认6张
      padding: 10px;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        transform: translateY(-5px);
      }

      &.active {
        transform: scale(1.05);
      }
    }

    .honor-image-wrapper {
      position: relative;
      width: 100%;
      height: 350px;
      border-radius: 10px;
      overflow: hidden;
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
      transition: all 0.3s ease;

      &:hover {
        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
      }
    }

    .honor-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.3s ease;
    }

    .honor-overlay {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      background: linear-gradient(transparent, rgba(0, 0, 0, 0.8));
      color: white;
      padding: 40px 25px 25px;
      transform: translateY(100%);
      transition: transform 0.3s ease;
    }

    .honor-image-wrapper:hover .honor-overlay {
      transform: translateY(0);
    }

    .honor-title {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 10px;
    }

    .honor-year {
      font-size: 16px;
      opacity: 0.9;
    }

    // 轮播控制按钮
    .carousel-btn {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      background: rgba(0, 0, 0, 0.7);
      color: white;
      border: none;
      width: 50px;
      height: 50px;
      border-radius: 50%;
      font-size: 24px;
      cursor: pointer;
      transition: all 0.3s ease;
      z-index: 10;

      &:hover:not(:disabled) {
        background: rgba(0, 0, 0, 0.9);
        transform: translateY(-50%) scale(1.1);
      }

      &:disabled {
        opacity: 0.3;
        cursor: not-allowed;
      }

      &.prev-btn {
        left: 15px;
      }

      &.next-btn {
        right: 15px;
      }
    }

    // 指示器
    .carousel-indicators {
      display: flex;
      justify-content: center;
      margin-top: 20px;
      gap: 10px;
    }

    .indicator {
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background: rgba(0, 0, 0, 0.3);
      cursor: pointer;
      transition: all 0.3s ease;

      &.active {
        background: @primary;
        transform: scale(1.2);
      }

      &:hover {
        background: @primary;
      }
    }

    // 响应式设计
    @media (max-width: 1199px) {
      .honor-slide {
        width: calc(100% / 4); // 中屏4张
      }
    }

    @media (max-width: 991px) {
      .honor-slide {
        width: calc(100% / 3); // 小屏3张
      }
    }

    @media (max-width: 767px) {
      .honor-slide {
        width: calc(100% / 2); // 更小屏2张
      }
    }

    @media (max-width: 575px) {
      .honor-slide {
        width: 100%; // 最小屏1张
      }
    }

    // 预览模态框样式
    .preview-modal {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.9);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 10000;
    }

    .preview-content {
      position: relative;
      max-width: 90%;
      max-height: 90%;
      background: white;
      border-radius: 15px;
      overflow: hidden;
      box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
    }

    .preview-image {
      width: 100%;
      height: auto;
      max-height: 70vh;
      object-fit: contain;
    }

    .preview-info {
      padding: 20px;
      text-align: center;

      h3 {
        color: @primary;
        margin-bottom: 10px;
      }

      p {
        margin: 5px 0;
        color: @words;
      }
    }

    .close-btn {
      position: absolute;
      top: 15px;
      right: 15px;
      background: rgba(0, 0, 0, 0.7);
      color: white;
      border: none;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      font-size: 20px;
      cursor: pointer;
      z-index: 10001;
    }

    .nav-btn {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      background: rgba(0, 0, 0, 0.7);
      color: white;
      border: none;
      width: 50px;
      height: 50px;
      border-radius: 50%;
      font-size: 24px;
      cursor: pointer;
      z-index: 10001;

      &.prev-btn {
        left: 15px;
      }

      &.next-btn {
        right: 15px;
      }
    }

    
  }

</style>